module.exports = __webpack_public_path__ + "img/taste-parallax3.0d1523be.jpg";